import { useEffect, useState } from "react";
import CardsDash from "../../../components/cards/receive-payments";
import ChartLine from "../../../components/chart/receive-payments";
import Footer from "../../../components/footer";
import ListCeCategoria from "../../../components/table/receive-payments/ce-categoria";
import ListClienteporTipo from "../../../components/table/receive-payments/ce-cliente-apagar";
import ListCsCategoria from "../../../components/table/receive-payments/cs-categoria";
import api from "../../../services/api";
import "./style.css";
import FilterModal from "../../../components/filter/Modal";
import functions from "../../../util/functions";
import reqReceitaseDespesas from "../../../services/reqReceitasDepesas";
// import reqContaSaida from "../../../services/reqContaSaida";
// import reqContaEntrada from "../../../services/reqContaEntrada";
import reqCliente from "../../../services/reqCliente";
import Notification, { handleMessageWarning } from "../../../components/toast";
import { ToastContainer } from "react-toastify";
import reqContaEntrada from "../../../services/reqMultiTenant/reqContaEntrada";
import reqContaSaida from "../../../services/reqMultiTenant/reqContaSaida";
import HeaderReport from "../../../components/header/report";
import HeaderListFilter from "../../../components/header/report-filter";

function DashBoard() {
	//#region  variaveis de estado
	const [receitas, setReceitas] = useState(0);
	const [receitasPagas, setReceitasPagas] = useState(0);
	const [receitasAtrasadas, setReceitasAtrasadas] = useState(0);
	const [receitasAReceber, setReceitasAReceber] = useState(0);
	const [receitasPercAReceber, setReceitasPercAReceber] = useState(0);
	const [receitasPercPagas, setReceitasPercPagas] = useState(0);
	const [despesasPercAReceber, setDespesasPercAReceber] = useState(0);
	const [despesasPercPagas, setDespesasPercPagas] = useState(0);
	const [despesas, setDespesas] = useState(0);
	const [despesasPagas, setDespesasPagas] = useState(0);
	const [despesasAtrasadas, setDespesasAtrasadas] = useState(0);
	const [despesasAReceber, setDespesasAReceber] = useState(0);

	const [listaContaEntrada, setListaContaEntrada] = useState([]);
	const [listaContaSaida, setListaContaSaida] = useState([]);

	const [dtini, setDtIni] = useState(new Date());
	const [dtfim, setDtFim] = useState(new Date());

	const [loading, setLoading] = useState(false);
	const [loadingCards, setLoadingCards] = useState(false);
	const [loadingCe, setLoadingCe] = useState(false);
	const [loadingCs, setLoadingCs] = useState(false);
	const [loadingCl, setLoadingCl] = useState(false);

	const [loadList, setLoadList] = useState(false);
	const [isFilterOpen, setIsFilterOpen] = useState(false);

	const [tipoData, setTipoData] = useState("dtVenda");
	const [selectedLabel, setSelectedLabel] = useState("Data da venda");
	//#endregion

	useEffect(() => {
		const valor = functions.iniFimMes();
		setDtIni(valor.inicioMes);
		setDtFim(valor.fimMes);
		setLoadList(true);
	}, []);

	const carregarListas = () => {
		setLoadList(true);
	};

	useEffect(() => {
		if (loadList) listReceivePayments();
	}, [loadList]);

	const listReceivePayments = () => {
		setLoadList(false);

		setListaContaEntrada([]);
		setListaContaSaida([]);

		setIsFilterOpen(false);
		setLoading(true);
		setLoadingCards(true);
		setLoadingCs(true);
		setLoadingCe(true);

		const dataini = functions.dateByString(dtini);
		const datafim = functions.dateByString(dtfim);

		receitaseDespesas(dataini, datafim);
		DespesasPorCategoria(dataini, datafim);
		ReceitasPorCategoria(dataini, datafim);
	};

	async function receitaseDespesas(dataIni, dataFim) {
		try {
			try {
				const response = await reqContaEntrada.listReceitaseDespesas(tipoData, dataIni, dataFim);

				setLoadingCards(true);
				if (response.status == 200) {
					response.data.map((res) => {
						if (res.tipo === "RECEITAS") {
							setReceitas(res.total);
							setReceitasAReceber(res.receber);
							setReceitasPagas(res.pago);
							setReceitasAtrasadas(res.atrasado);
							setReceitasPercAReceber(res.percreceber);
							setReceitasPercPagas(res.percpago);
						} else {
							if (res.tipo === "DESPESAS") {
								setDespesas(res.total);
								setDespesasAReceber(res.receber);
								setDespesasPagas(res.pago);
								setDespesasAtrasadas(res.atrasado);
								setDespesasPercAReceber(res.percreceber);
								setDespesasPercPagas(res.percpago);
							}
						}
					});
				}
			} catch (error) {
				handleMessageWarning(error.message);
			}
		} finally {
			setLoadingCards(false);
		}
	}

	async function DespesasPorCategoria(dataIni, dataFim) {
		try {
			try {
				const response = await reqContaSaida.listCategoria(tipoData, dataIni, dataFim);
				if (response.data) setListaContaSaida(response.data);
			} catch (error) {
				handleMessageWarning(error.message);
			}
		} finally {
			setLoadingCs(false);
		}
	}

	async function ReceitasPorCategoria(dataIni, dataFim) {
		try {
			try {
				const response = await reqContaEntrada.listReceitasCategoria(tipoData, dataIni, dataFim);
				if (response.data) setListaContaEntrada(response.data);
			} catch (error) {
				handleMessageWarning(error.message);
			}
		} finally {
			setLoadingCe(false);
		}
	}

	const handleRadioChangeData = (value, label) => {
		setTipoData(value);
		setSelectedLabel(label);
	};

	function openFilter() {
		setIsFilterOpen(!isFilterOpen);
	}

	function closeFilter() {
		setIsFilterOpen(false);
	}

	return (
		<>
			<div className="container-fluid mt-page">
				<ToastContainer />

				{/* HEADER PADRONIZADO */}
				<header className="flex flex-col bg-white p-2 rounded-sm box-shadow-md mb-6">
					<div className="grid grid-cols-2">
						<div className="col-span-1">
							<HeaderReport
								title="Movimentação de Receitas vs Despesas"
								subTitle="Este relatório não deve ser utilizado para controle de faturamento. Seu objetivo é confrontar receitas e despesas do período, com base na data da parcela ou data da venda."
							/>
						</div>
						<div className="col-span-1 flex justify-end mb-2">
							<div className="flex flex-col gap-1">
								<HeaderListFilter
									filterData={{
										opcao: {
											label: "Opção selecionada",
											value: selectedLabel,
										},
										periodo: {
											label: "Período",
											value: `${functions.dateByString(dtini)} à ${functions.dateByString(dtfim)}`,
										},
									}}
								/>
							</div>
						</div>
					</div>

					<div className="col-span-1 flex justify-end items-end mt-2">
						<div className="flex gap-2 h-8">
							<button className="btn btn-sm btn-primary w-32" onClick={openFilter}>
								Filtrar
							</button>
						</div>
					</div>
					<div className="border-bottom mt-3"></div>
				</header>

				<FilterModal //
					title={"Movimentação"}
					isOpen={isFilterOpen}
					onRequestClose={closeFilter}
					filterName={false}
					filterLate={false}
					dtini={dtini}
					dtfim={dtfim}
					setDtIni={setDtIni}
					setDtFim={setDtFim}
					handleList={carregarListas}
					filterData={true}
					tipoData={handleRadioChangeData}
				/>

				<div className="">
					<CardsDash //
						receitas={receitas}
						receitasPagas={receitasPagas}
						receitasAtrasadas={receitasAtrasadas}
						receitasAReceber={receitasAReceber}
						receitasPercAReceber={receitasPercAReceber}
						receitasPercPagas={receitasPercPagas}
						despesasPercAReceber={despesasPercAReceber}
						despesasPercPagas={despesasPercPagas}
						despesas={despesas}
						despesasPagas={despesasPagas}
						despesasAtrasadas={despesasAtrasadas}
						despesasAReceber={despesasAReceber}
						loading={loadingCards}
					/>
				</div>

				<div className="row">
					<h2 className="mt-4">Movimentação por Categoria</h2>
				</div>

				<div className="row">
					<div className="col-sm-12 col-md-6 col-xl-4 col-lg-4">
						<ListCeCategoria listaContaEntrada={listaContaEntrada} loading={loadingCe} />
					</div>

					<div className="col-sm-12 col-md-6 col-xl-4 col-lg-4">
						<ListCsCategoria listaContaSaida={listaContaSaida} loading={loadingCs} />
					</div>
					<div className="mt-3 col-sm-12 col-md-6 col-xl-4 col-lg-4">
						<h6 className="text-secondary">Entrada vs Saídas</h6>
						<div className="">
							<ChartLine //
								receitas={receitas}
								receitasPagas={receitasPagas}
								receitasAtrasadas={receitasAtrasadas}
								receitasAReceber={receitasAReceber}
								despesas={despesas}
								despesasPagas={despesasPagas}
								despesasAtrasadas={despesasAtrasadas}
								despesasAReceber={despesasAReceber}
								loading={loadingCards}
							/>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default DashBoard;
